import { IAcademy, IDepartment, ISubject } from '../types/departamento';
import { ApiError, apiErrorMessage, request } from './http';

export { ApiError, apiErrorMessage };

/** Stored department images are http(s) URLs. A newly picked file is sent separately. */
export const httpImageUrl = (value: string | null | undefined): string | null => {
	if (typeof value === 'string' && /^https?:\/\//i.test(value)) return value;
	return null;
};

export const listDepartments = (): Promise<IDepartment[]> => request('/api/departments');

export interface DepartmentWrite {
	name: string;
	description: string;
	imageUrl: string | null;
	color: string;
}

const departmentBody = (body: DepartmentWrite, image?: File | null): BodyInit => {
	if (!image) return JSON.stringify(body);
	const form = new FormData();
	form.append('name', body.name);
	form.append('description', body.description);
	form.append('color', body.color);
	if (body.imageUrl) form.append('imageUrl', body.imageUrl);
	form.append('image', image);
	return form;
};

export const createDepartment = (body: DepartmentWrite, image?: File | null): Promise<IDepartment> =>
	request('/api/departments', { method: 'POST', body: departmentBody(body, image) });

export const updateDepartment = (
	id: number,
	body: DepartmentWrite,
	image?: File | null
): Promise<IDepartment> =>
	request(`/api/departments/${id}`, { method: 'PUT', body: departmentBody(body, image) });

export const deleteDepartment = (id: number): Promise<void> =>
	request(`/api/departments/${id}`, { method: 'DELETE' });

export const listAcademies = (departmentId: number): Promise<IAcademy[]> =>
	request(`/api/departments/${departmentId}/academies`);

export const createAcademy = (departmentId: number, body: { name: string }): Promise<IAcademy> =>
	request(`/api/departments/${departmentId}/academies`, {
		method: 'POST',
		body: JSON.stringify(body),
	});

export const updateAcademy = (id: number, body: { name: string }): Promise<IAcademy> =>
	request(`/api/academies/${id}`, { method: 'PUT', body: JSON.stringify(body) });

export const deleteAcademy = (id: number): Promise<void> =>
	request(`/api/academies/${id}`, { method: 'DELETE' });

export const listSubjects = (academyId: number): Promise<ISubject[]> =>
	request(`/api/academies/${academyId}/subjects`);

/** Flat catalog. Roles: ADMINISTRADOR, AUDITOR, DOCENTE. */
export const listCatalogSubjects = (): Promise<ISubject[]> => request('/api/subjects');

export const createSubject = (academyId: number, body: { name: string }): Promise<ISubject> =>
	request(`/api/academies/${academyId}/subjects`, {
		method: 'POST',
		body: JSON.stringify(body),
	});

export const updateSubject = (id: number, body: { name: string }): Promise<ISubject> =>
	request(`/api/subjects/${id}`, { method: 'PUT', body: JSON.stringify(body) });

export const deleteSubject = (id: number): Promise<void> =>
	request(`/api/subjects/${id}`, { method: 'DELETE' });
